import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useDebounce } from 'hooks/useDebounce'
import React from 'react'
import { useToasts } from 'react-toast-notifications'
import subsidiariesApi from 'services/api/subsidiaries'

import styles from './FindHotelByInvoiceIdDialog.module.scss'

const FindHotelByInvoiceIdDialog = ({ onClose }) => {
  const { addToast } = useToasts()

  const [hotel, setHotel] = React.useState()
  const [invoiceId, setinvoiceId] = React.useState()

  const debouncedInvoiceId = useDebounce(invoiceId, 500)

  React.useEffect(() => {
    if (!debouncedInvoiceId || debouncedInvoiceId.length < 4) {
      setHotel(null)
      return
    }

    subsidiariesApi.find
      .byInvoiceId({ invoiceId: debouncedInvoiceId })
      .then(res => {
        if (res) {
          setHotel(res)
          addToast(`${res.hotelName} found with invoice id of #${debouncedInvoiceId}`, {
            appearance: 'success'
          })
        } else {
          setHotel(null)
        }
      })
      .catch(err => {
        setHotel(null)
        if (err.message.includes('Invoice not found')) {
          addToast(`Invoice not found with id of ${debouncedInvoiceId}`, {
            appearance: 'error'
          })
          return
        }

        addToast('Something went wrong', { appearance: 'error' })
      })
  }, [addToast, debouncedInvoiceId])

  return (
    <ConfirmationDialog
      title="Find hotel with invoice id"
      theme="blacklist"
      maxWidth={800}
      positiveMessage={hotel ? `Switch to hotel #${hotel.displayId}` : 'Switch to hotel'}
      negativeMessage="Cancel"
      isButtonDisabled={!hotel}
      confirmLink={hotel && `/s/${hotel.id}/billing`}
      onClose={onClose}
    >
      <div className={styles.wrapper}>
        <TextInput label="Invoice id" onChangeValue={setinvoiceId} value={invoiceId} />
      </div>
    </ConfirmationDialog>
  )
}

export default FindHotelByInvoiceIdDialog
